import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, Space, Select } from "antd";
import { COLORS } from "../../layout/theme/colors/Colors";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../utils/notificationToast";
import { get_clients_name_list } from "../../../api/endpoints/clients";
import { create_client_config } from "../../../api/endpoints/distributors";

const GUTTER = 10;

export default function AddDistributorClientConfig({
	distributorId,
	updateData,
	setState,
	availableSendTypes,
	availableTypesOfFiles,
	initialSendType,
	initialFileType,
}) {
	const [form] = Form.useForm();
	const [clients, setClients] = useState(null);

	useEffect(() => {
		const fetch_market_client_list = async () => {
			const res = await get_clients_name_list();
			setClients(
				res
					?.filter((c) => c.isSeller)
					?.map((r) => ({
						value: r.id,
						label: r.name,
					}))
			);
		};

		fetch_market_client_list();
	}, []);

	const onFinish = async (values) => {
		try {
			const laboratorySendInfoMobile = {
				send: initialSendType,
				format: initialFileType,
				server: values.laboratoryServerMobile ?? "",
				port: values.laboratoryPortMobile ?? "",
				user: values.laboratoryUserMobile ?? "",
				password: values.laboratoryPasswordMobile ?? "",
				folder: values.laboratoryFolderMobile ?? "",
			};

			const postData = {
				id: distributorId,
				client: {
					clientId: values.laboratory,
					distributorId: distributorId,
					sendProtocol: null,
					columnsToSend: null,
					typeOfArchive: null,
					mobileSendProtocol: initialSendType,
					mobileColumnsToSend: null,
					mobileTypeOfArchive: JSON.stringify(laboratorySendInfoMobile),
					mobileEmail: null,
				},
			};
			const res = await create_client_config(postData);

			openNotificationWithIcon(
				TYPE.SUCCESS,
				"Configuracion agregada con exito",
				"La configuracion del laboratorio se agrego con exito"
			);
			updateData();
		} catch (err) {
			openNotificationWithIcon(
				TYPE.SUCCESS,
				"La configuracion no se pudo agregar",
				"Complete todos los datos o contacte con soporte a soporte@checkpos.com"
			);
			console.log(err);
		} finally {
			setState(false);
		}
	};
	return (
		<Form
			form={form}
			name="basic"
			onFinish={onFinish}
			autoComplete="off"
			requiredMark={false}
			layout="vertical"
		>
			<Space direction="vertical" size="middle" style={{ display: "flex" }}>
				<Row gutter={GUTTER}>
					<Col span={12}>
						<Form.Item
							name="laboratory"
							label={
								<label style={{ color: COLORS.Primary, fontWeight: "600" }}>
									Laboratorio
								</label>
							}
							rules={[
								{
									required: true,
									message: "Este campo es obligatorio",
								},
							]}
						>
							<Select
								showSearch
								placeholder="Elegi un laboratorio"
								optionFilterProp="children"
								filterOption={(input, option) =>
									(option?.label ?? "")
										.toLowerCase()
										.includes(input.toLowerCase())
								}
								options={clients}
								style={{ width: 200 }}
							/>
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={GUTTER}>
					<Col span={12}>
						<Form.Item
							label={
								<label style={{ color: COLORS.Primary, fontWeight: "600" }}>
									Tipo de envio
								</label>
							}
							// name="laboratorySendMobile"
							rules={[
								{
									required: true,
									message: "Por favor, seleccione el tipo de envío",
								},
							]}
						>
							<Select
								defaultValue={initialSendType}
								placeholder="Tipo de envio"
								disabled
							>
								{availableSendTypes.map((item) => (
									<Select.Option key={item} value={item}>
										{item}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label={
								<label style={{ color: COLORS.Primary, fontWeight: "600" }}>
									Formato
								</label>
							}
							// name="laboratoryFormatMobile"
							rules={[
								{
									required: true,
									message: "Por favor, seleccione el formato de archivo",
								},
							]}
						>
							<Select defaultValue={initialFileType} disabled>
								{availableTypesOfFiles.map((item) => (
									<Select.Option key={item} value={item}>
										{item}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={GUTTER}>
					<Col span={8}>
						<Form.Item
							label={
								<label style={{ color: COLORS.Primary, fontWeight: "600" }}>
									Servidor
								</label>
							}
							name="laboratoryServerMobile"
							rules={[
								({ getFieldValue }) => ({
									validator(_, value) {
										const sendValue = getFieldValue("sendMobile");

										if (sendValue === "sftp") {
											if (!value) {
												return Promise.reject(
													"Por favor ingrese un servidor para envio sftp"
												);
											}
										}

										return Promise.resolve();
									},
								}),
							]}
						>
							<Input placeholder="Servidor" />
						</Form.Item>
					</Col>
					<Col span={8}>
						<Form.Item
							label={
								<label style={{ color: COLORS.Primary, fontWeight: "600" }}>
									Puerto
								</label>
							}
							name="laboratoryPortMobile"
							rules={[
								({ getFieldValue }) => ({
									validator(_, value) {
										const sendValue = getFieldValue("sendMobile");

										if (sendValue === "sftp") {
											if (!value) {
												return Promise.reject(
													"Por favor ingrese un puerto para envio sftp"
												);
											}
										}

										return Promise.resolve();
									},
								}),
							]}
						>
							<Input placeholder="Puerto" />
						</Form.Item>
					</Col>
					<Col span={8}>
						<Form.Item
							label={
								<label style={{ color: COLORS.Primary, fontWeight: "600" }}>
									Carpeta
								</label>
							}
							name="laboratoryFolderMobile"
							rules={[
								({ getFieldValue }) => ({
									validator(_, value) {
										const sendValue = getFieldValue("sendMobile");

										if (sendValue === "sftp") {
											if (!value) {
												return Promise.reject(
													"Por favor ingrese una carpeta para envio sftp"
												);
											}
										}

										return Promise.resolve();
									},
								}),
							]}
						>
							<Input placeholder="Carpeta" />
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={GUTTER}>
					<Col span={12}>
						<Form.Item
							label={
								<label style={{ color: COLORS.Primary, fontWeight: "600" }}>
									Usuario
								</label>
							}
							name="laboratoryUserMobile"
							rules={[
								({ getFieldValue }) => ({
									validator(_, value) {
										const sendValue = getFieldValue("sendMobile");

										if (sendValue === "sftp") {
											if (!value) {
												return Promise.reject(
													"Por favor ingrese un usuario para envio sftp"
												);
											}
										}

										return Promise.resolve();
									},
								}),
							]}
						>
							<Input placeholder="Usuario" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label={
								<label style={{ color: COLORS.Primary, fontWeight: "600" }}>
									Contraseña
								</label>
							}
							name="laboratoryPasswordMobile"
							rules={[
								({ getFieldValue }) => ({
									validator(_, value) {
										const sendValue = getFieldValue("sendMobile");

										if (sendValue === "sftp") {
											if (!value) {
												return Promise.reject(
													"Por favor ingrese una contraseña para envio sftp"
												);
											}
										}

										return Promise.resolve();
									},
								}),
							]}
						>
							<Input placeholder="Contraseña" />
						</Form.Item>
					</Col>
				</Row>

				<Form.Item>
					<Button type="primary" htmlType="submit">
						Guardar
					</Button>
				</Form.Item>
			</Space>
		</Form>
	);
}
